import React from 'react';
import { Tooltip } from '@mui/material';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import { useAiAssistant } from './aiAssistantContext';
import { TriggerButton } from './aiAssistant.styles';

/** Top-bar entry point. Renders nothing when the org doesn't have the assistant (AI Bridge or its assistant switch off). */
export const AiAssistantButton = () => {
    const assistant = useAiAssistant();
    if (!assistant?.isEnabled) return null;

    return (
        <Tooltip title={assistant.isOpen ? 'Hide assistant' : 'Open assistant'}>
            <TriggerButton type="button" active={assistant.isOpen} onClick={assistant.toggle} aria-expanded={assistant.isOpen}>
                <AutoAwesomeRoundedIcon />
                Ask AI
            </TriggerButton>
        </Tooltip>
    );
};
